/* global _BEAMER_PRODUCT_ID */

import {
  PLATFORM_ANNONCEMENTS_GET_START,
  PLATFORM_ANNONCEMENTS_GET_SUCCESS,
} from './actions';

import { selectPlatformAnnouncementsLoading } from './selectors';
import { currentUserSelector, currentUserIsEducator } from '../Users/selectors';

export const openAnnouncements = () => {
  if (window.Beamer && window.Beamer.show) {
    window.Beamer.show();
  }
};

export const getAnnouncements = (dispatch, getState) => {
  if (!_BEAMER_PRODUCT_ID) {
    return;
  }
  const state = getState();
  if (selectPlatformAnnouncementsLoading(state)) {
    return;
  }
  const currentUser = currentUserSelector(state);
  if (!currentUser) {
    return;
  }
  const userIsEducator = currentUserIsEducator(state);

  /* beamer integration */
  const beamerCallback = (posts) => {
    dispatch({ type: PLATFORM_ANNONCEMENTS_GET_SUCCESS, posts });
  };
  const [userFirstName, userLastName] = currentUser.get('fullName').split(' ');
  window.beamer_config = {
    product_id: _BEAMER_PRODUCT_ID,
    // selector: undefined, // ignored if alert is false
    display: 'right',
    top: 0,
    right: 0,
    // button_position: undefined, // ignored if button is false
    language: 'EN',
    filter: [
      userIsEducator ? 'educator' : null, // if user is an educator
    ]
      .filter((value) => value != null)
      .join(';'),
    lazy: false,
    alert: false,
    button: false,
    callback: beamerCallback,
    // Visitor Information
    user_id: currentUser.get('id'),
    user_firstname: userFirstName,
    user_lastname: userLastName,
    user_email: currentUser.get('email'),
  };
  const beamerScript = document.createElement('script');
  beamerScript.type = 'text/javascript';
  beamerScript.src = 'https://app.getbeamer.com/js/beamer-embed.js';
  beamerScript.defer = 'defer';
  document.body.appendChild(beamerScript);

  dispatch({ type: PLATFORM_ANNONCEMENTS_GET_START });
};
